import moment from 'moment';
import cookies from './cookies';
import { getLocatDate } from './converter';

export const getFee = (fee, fees, awb, info = false) => {
  let cost = 0;
  let type = fee.type == 'add' ? 1 : -1;
  let unit = fee.unit;
  if (unit == 'cost') {
    cost = type * fee.cost;
  }
  if (unit == 'percent') {
    let other_fee = fees.find(f => f.key == fee.from_service);
    if (other_fee) {
      let other_cost = 0;
      other_fee?.value?.forEach((v) => {
        other_cost += getFee(v, fees);
      });
      cost = type * ((other_cost / 100) * fee.percent);
    } else {
      cost = type * 0;
    }
  }
  if (unit == 'cost_manual') {
    cost = type * (fee?.cost_value || 0);
  }
  if (unit == 'number') {
    cost = type * (fee?.cost_per_unit * (fee?.unit_value || 0));
  }

  if (unit == 'kg') {
    cost = type * (fee?.cost_per_unit * parseFloat(awb?.wgt || 0));
  }

  if (unit == 'kg_per_day') {
    // {
    //   "type": "add",
    //   "unit": "kg_per_day",
    //   "unit_divisor": 1,
    //   "free_days": "2",
    //   "cost_per_unit": "0.1",
    //   "mim_cost_per_day": "40",
    //   "first_weekend_free": true,
    //   "all_public_holidays_counted": true,
    //   "arrival_day_counted": true,
    //   "first_weekend_holiday_free_without_day_after_free_period": true,
    //   "first_public_holiday_counted": true
    // }

    // new code
    const setNextDateString = (date) => {
      return moment(date).add(1, 'days').format('YYYY-MM-DD');
    };

    const setNextDate = (date) => {
      return moment(date).add(1, 'days').toDate();
    };

    const isFreeDaysFromHolidays = (holidays, date) => {
      return holidays.find(h => h == date) != null;
    };

    const isFreeDaysFromWeekend = (date) => {
      return date.getDay() == 0 || date.getDay() == 6;
    };

    const holidays = cookies.get('holidays') || [];
    const timing = cookies.get('station_timing') || [];
    console.log('timing', timing);
    const arrival_day_counted = fee.arrival_day_counted;
    let startDate = awb?.storage_start;
    let pickupdate = awb?.pickup_date ? awb?.pickup_date : getLocatDate();
    if (fee?.office_hour_counted) {
      let arrival_time = moment(awb?.sstorage_start_date_time).format('HH:mm');
      let day_name = moment(awb?.sstorage_start_date_time).format('dddd');
      let day_timing = timing.find(t => t.day == day_name);
      if (day_timing) {
        if (arrival_time > day_timing.close) {
          startDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');
        }
      }
    }
    if (!arrival_day_counted) {
      startDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');
    }
    const first_weekend_holiday_free_without_day_after_free_period = fee.first_weekend_holiday_free_without_day_after_free_period;
    const free_days = parseInt(fee.free_days);
    const all_public_holidays_counted = fee.all_public_holidays_counted;
    const first_public_holiday_counted = fee.first_public_holiday_counted;
    const first_weekend_free = fee.first_weekend_free;
    const storage_divisor = fee.unit_divisor;
    const rounding = fee.rounding;
    const cost_per_unit = fee.cost_per_unit;
    const mim_cost_per_day = fee.mim_cost_per_day;
    let totalFreeDays = parseInt(free_days);

    let dateCheckHoliday = startDate;
    let dateCheckWeekend = moment(startDate).toDate();
    let weekend_holiday_not_free_after_free_period = fee.weekend_holiday_not_free_after_free_period || false;
    let count = first_weekend_holiday_free_without_day_after_free_period ? free_days : free_days + 1;
    if (!weekend_holiday_not_free_after_free_period) {
      let days = Math.ceil((moment(pickupdate).toDate().getTime() - moment(startDate).toDate().getTime()) / (24 * 60 * 60 * 1000)) + 1;
      if (days > count) {
        count = days;
      }
    }
    if (all_public_holidays_counted || first_public_holiday_counted || first_weekend_free) {
      let idIsFirstHolidayDay = false;
      for (let i = 0; i < count; i += 1) {
        const isDayHoliday = first_public_holiday_counted && !idIsFirstHolidayDay ? isFreeDaysFromHolidays(holidays, dateCheckHoliday) : false;
        const isDayWeekend = first_weekend_free ? isFreeDaysFromWeekend(dateCheckWeekend) : false;
        if (isDayHoliday || isDayWeekend) {
          totalFreeDays += 1;
          dateCheckHoliday = setNextDateString(dateCheckHoliday);
          dateCheckWeekend = setNextDate(dateCheckWeekend);
          count += 1;
          if (isDayHoliday && !all_public_holidays_counted) {
            idIsFirstHolidayDay = true;
          }
        } else if (i <= free_days + 1) {
          dateCheckHoliday = setNextDateString(dateCheckHoliday);
          dateCheckWeekend = setNextDate(dateCheckWeekend);
        } else {
          break;
        }
      }
    }

    if (awb?.manual_storage_start) {
      startDate = awb?.manual_storage_start;
      totalFreeDays = 0;
    }
    let chargableDays = Math.ceil((moment(pickupdate).toDate().getTime() - moment(startDate).toDate().getTime()) / (24 * 60 * 60 * 1000)) + 1 - totalFreeDays;
    if (chargableDays < 0) {
      chargableDays = 0;
    }
    let storageUnits = parseFloat(awb?.wgt) / parseFloat(storage_divisor);

    if (rounding == 'wgt') {
      storageUnits = Math.round(storageUnits);
    }
    let storageFee = 0;
    let totalMinCost = 0;
    let display_storage_fee = 0;
    let display_min_cost = 0;

    if (fee?.rate_applied_on && fee?.rate_applied_on == 'per_day') {
      storageFee = (storageUnits || 0) * cost_per_unit * chargableDays;
      totalMinCost = mim_cost_per_day * chargableDays;
      if (chargableDays > 0) {
        display_storage_fee = storageFee;
        display_min_cost = totalMinCost;
      } else {
        display_storage_fee = (storageUnits || 0) * cost_per_unit;
        display_min_cost = mim_cost_per_day;
      }
    } else {
      storageFee = (storageUnits || 0) * cost_per_unit * chargableDays;
      totalMinCost = chargableDays > 0 ? mim_cost_per_day : 0;
      if (chargableDays > 0) {
        display_storage_fee = storageFee;
        display_min_cost = totalMinCost;
      } else {
        display_storage_fee = (storageUnits || 0) * cost_per_unit;
        display_min_cost = mim_cost_per_day;
      }
    }
    let min = false;

    let display_max = Math.max(display_storage_fee, display_min_cost);

    if (display_min_cost == display_max) {
      min = true;
    }

    let max = Math.max(storageFee, totalMinCost);

    cost = type * parseFloat(max);

    if (rounding == 'cost') {
      cost = Math.round(cost);
    }
    if (info) {
      return {
        cost: cost,
        awb_recv: awb?.storage_start,
        storage_start: awb?.manual_storage_start ? awb?.manual_storage_start : (totalFreeDays > 0 ? moment(startDate).add(totalFreeDays, 'days').format('YYYY-MM-DD') : startDate),
        storageFee,
        mim_cost_per_day,
        display_storage_fee,
        display_min_cost,
        totalMinCost,
        chargableDays,
        storageUnits,
        cost_per_unit,
        totalFreeDays,
        pickupdate,
        min,
        startDate
      };
    }
  }
  return cost;
};


const calculateFees = (fees, awb) => {
  let totalCost = 0;
  let services = [];
  fees.forEach((fee) => {
    let c = 0;
    let add_info = [];
    if (fee.value && fee.value?.length > 0) {
      fee.value.forEach((v) => {
        c += parseFloat(getFee(v, fees, awb));
        if (v.unit == 'kg_per_day') {
          add_info.push(getFee(v, fees, awb, true));
        }
      });
    }
    services.push({
      ...fee,
      cost: c,
      additional_info: add_info
    });
    totalCost += parseFloat(c);
  });
  return {
    totalCost,
    services
  };
};

export default calculateFees;